<template>
    <svg
        class="text-gray-600"
        fill="currentColor"
        width="48"
        height="48"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle class="spinner" cx="4" cy="12" r="3" />
        <circle class="spinner spinner_1" cx="12" cy="12" r="3" />
        <circle class="spinner spinner_2" cx="20" cy="12" r="3" />
    </svg>
</template>

<style scoped>
@keyframes spinner_x {
    93.75%,
    100% {
        r: 3px;
    }
    46.875% {
        r: 0.2px;
    }
}
.spinner {
    animation: spinner_x 0.8s linear infinite;
}
.spinner_1 {
    animation-delay: -0.65s;
}
.spinner_2 {
    animation-delay: -0.5s;
}
</style>
